import { useEffect } from "react";
import { useAlertToast, setToastFunctions } from "@/contexts/AlertToastContext";

// This component syncs the toast functions for the singleton
export function AlertToastSync() {
  const toastContext = useAlertToast();
  
  useEffect(() => {
    setToastFunctions(toastContext);
  }, [toastContext]);
  
  return null;
}
